import React from 'react';
import { Prompt, Category } from '../types';
import DesktopPromptModal from './DesktopPromptModal';
import MobilePromptModal from './MobilePromptModal';

interface PromptModalProps {
  prompt: Prompt;
  isOpen: boolean;
  onClose: () => void;
  onMarkerClick?: ( marker: string) => void;
  onEdit?: (prompt: Prompt) => void;
  onDelete?: (id: string) => void;
  userRole?: string;
  categories: Category[];
  currentUserId?: string;
}

const PromptModal: React.FC<
PromptModalProps
> = ({

  onMarkerClick,

  prompt,

  isOpen,

  onClose,

  onEdit,

  onDelete,

  userRole,

  categories,

  currentUserId,

}) => {

  const [isMobile, setIsMobile] =
  React.useState(false);

    React.useEffect(() => {

  const checkMobile = () => {

    setIsMobile(
      window.innerWidth < 768
    );

  };

  checkMobile();

  window.addEventListener(
    'resize',
    checkMobile
  );

  return () => {

    window.removeEventListener(
      'resize',
      checkMobile
    );

  };

}, []);

const modalProps = {
  prompt,
  isOpen,
  onClose,
  onMarkerClick,
  onEdit,
  onDelete,
  userRole,
  categories,
  currentUserId,
};

  return isMobile ? (
  <MobilePromptModal {...modalProps} />
) : (
  <DesktopPromptModal {...modalProps} />
);
  };

export default PromptModal;
